export default "__VITE_ASSET__BvJqwe5o__"